import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=6fabe2a3&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fabe2a3')) {
      api.createRecord('6fabe2a3', component.options)
    } else {
      api.reload('6fabe2a3', component.options)
    }
    module.hot.accept("./UsersList.vue?vue&type=template&id=6fabe2a3&", function () {
      api.rerender('6fabe2a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rolemanagement/users/UsersList.vue"
export default component.exports